<div class="pull-right">
    <mat-button-toggle-group [formControl]="formType">
        <mat-button-toggle value="operations">Operations</mat-button-toggle>
        <mat-button-toggle value="quality">Quality</mat-button-toggle>
        <mat-button-toggle value="it" *userAllowed="'add_it_requests'">IT</mat-button-toggle>
    </mat-button-toggle-group>
</div>

<div class="flex">
    <h1 class="container-heading">
        {{ action | ucfirst }} request
    </h1>
    <div class="padding-top-10 padding-left-10">
        <button type="button"
                mat-icon-button
                (click)="minimizeRequest()"
                matTooltip="Minimize request">
            <mat-icon class="fa-rotate-270"> call_received</mat-icon>
        </button>
    </div>
</div>

<mat-card>
    <mat-card-content>
        <section-operations-request-form *ngIf="formType.value==='operations'"
                                         (onClose)="close()"
                                         (onMinimize)="minimizeRequest()"
                                         [data]="modal.params.data"
                                         (onSubmit)="close()"></section-operations-request-form>

        <section-it-request-form *ngIf="formType.value==='it'"
                                 (onClose)="close()"
                                 (onMinimize)="minimizeRequest()"
                                 [data]="modal.params.data"
                                 (onSubmit)="close()"></section-it-request-form>

        <section-quality-request-form *ngIf="formType.value==='quality'"
                                      (onClose)="close()"
                                      (onMinimize)="minimizeRequest()"
                                      [data]="modal.params.data"
                                      (onSubmit)="close()"></section-quality-request-form>
    </mat-card-content>
</mat-card>
